import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Compass, Ticket, User, Shield, FileText } from 'lucide-react';
import { useAuth } from '../App';
import StridesBalance from './StridesBalance';

const MobileNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const navItems = [
    { icon: Compass, label: 'Explore', path: '/', testId: 'nav-home' },
    { icon: FileText, label: 'Blog', path: '/blog', testId: 'nav-blog' },
    { icon: Ticket, label: 'My Tours', path: '/my-tours', testId: 'nav-my-tours' },
    { icon: User, label: 'Profile', path: '/profile', testId: 'nav-profile' },
  ];

  if (user?.account_type === 'admin') {
    navItems.push({ icon: Shield, label: 'Admin', path: '/admin', testId: 'nav-admin' });
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-lg border-t border-slate-200/50 z-50">
      {/* Strides balance pill — only visible to logged-in users */}
      {user && (
        <div className="absolute -top-4 right-3 z-10">
          <StridesBalance compact onClick={() => navigate('/profile')} />
        </div>
      )}
      <div className="flex items-center justify-around px-2 py-3">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              data-testid={item.testId}
              className={`flex flex-col items-center justify-center min-w-[60px] py-2 rounded-lg transition-all ${
                isActive
                  ? 'text-teal-600'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
              }`}
            >
              <Icon className={`w-6 h-6 mb-1 ${isActive ? 'text-teal-600' : ''}`} />
              <span className={`text-xs font-semibold font-body ${isActive ? 'text-teal-600' : ''}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;